/**
 * Where access requests are answered: the Permissions page's Requests, at `/permissions/requests`
 * (#6596). A notification about one request opens it there, named in the query string.
 */
export const ACCESS_REQUESTS_PATH = "/permissions/requests";

/** The query parameter naming the request a notification is about. */
export const ACCESS_REQUEST_PARAMETER = "request";

export function accessRequestPath(accessRequestId: string): string {
  return `${ACCESS_REQUESTS_PATH}?${ACCESS_REQUEST_PARAMETER}=${accessRequestId}`;
}

/**
 * A backslash, which a browser reads as a slash, or a control character, which it strips before it
 * parses: either can turn "/" + something into "//another.site" (review of #6804).
 */
const UNSAFE_PATH_CHARACTER = /[\\\u0000-\u001f\u007f]/;

/** Whether a path a request carries is one inside the app, and so safe to link to. */
export function isInAppPath(path: string | undefined): path is string {
  return !!path && path.startsWith("/") && !path.startsWith("//") && !UNSAFE_PATH_CHARACTER.test(path);
}
